import { Calendar, DateObject } from "react-multi-date-picker"
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useParams, useNavigate, useNavigation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Paper from '@mui/material/Paper';

import loader from '../../images/loader.gif';
import { BaseURL } from '../../common/URLs';
import { Button, Container, Stack, Typography, Card, Popover, TextField, CardContent } from '@mui/material';
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from '@mui/system';
import moment from 'moment';
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import EditIcon from '@mui/icons-material/Edit';
import { API_DATE_FORMAT, BASIC_DATE_FORMAT, HELPDESK_ROLES, PROD } from '../../common/constants';
import { toast } from 'react-toastify';
import { Refresh } from "@mui/icons-material";
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { loaderService } from "../../common/custom-loader/loader-service";
import apiClient from "../../axios";

const columns = [
  { id: 'name', label: 'Holiday Name', minWidth: 170 },
  { id: 'date', label: 'Holiday Date', minWidth: 100 },
  { id: 'year', label: 'Year', minWidth: 50 },
  { id: 'menu', label: ' ', minWidth: 30 },
]

function HolidayList() {
  const [holidays, setHolidays] = useState([]);
  // const [isLoading, setLoading] = useState(true)
  const [open, setOpen] = useState(false);
  const [holidayDetails, setHolidayDetails] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [holidayGridData, setHolidayGridData] = useState([]);
  const [hitSelectedDates, setHitSelectedDates] = useState([]);
  const [holidayAllDates, setHolidayAllDates] = useState([]);
  const [filteredDates, setFilteredDates] = useState([]);
  const [newDates, setNewDates] = useState([]);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [isApiCalled, setIsApiCalled] = useState(false);

  const convertDate = (date) => {
    return moment(date, "YYYY-MM-DD").format('DD-MM-YYYY')
  }

  const reverseconvertDate = (date) => {
    return moment(date, "DD-MM-YYYY").format('YYYY-MM-DD')
  }

  const navigate = useNavigate();

  useEffect(() => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchHoliday",
      {},
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token'),
        }
      }
    ).then((response) => {
      let data = []
      if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser) {
        data = response.data.filter((item) => item.extFlag === 1);
      }
      else {
        data = response.data.filter((item) => item.extFlag === 0);
      }
      setHolidays(data);
      // setLoading(false)

      let templateData = [
        { id: 1, month: 'APR', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 2, month: 'MAY', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 3, month: 'JUN', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 4, month: 'JUL', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 5, month: 'AUG', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 6, month: 'SEP', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 7, month: 'OCT', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 8, month: 'NOV', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 9, month: 'DEC', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 10, month: 'JAN', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 11, month: 'FEB', holidayCount: 0, holidayDates: [], holidayDays: [] },
        { id: 12, month: 'MAR', holidayCount: 0, holidayDates: [], holidayDays: [] },
      ]

      let allHolidayDates = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        // console.log(element,'element');
        let holidayCount = 0;
        let holidayDates = [];
        let holidayDays = [];
        for (let j = 0; j < templateData.length; j++) {
          const tempMonth = templateData[j];
          if (tempMonth.month.toLowerCase() == moment(element.fromDateStr).format("MMM").toLowerCase()) {
            holidayCount = tempMonth.holidayCount + 1;
            holidayDates = tempMonth.holidayDates;
            holidayDates.push(element.fromDateStr);
            holidayDays = tempMonth.holidayDays;
            holidayDays.push(moment(element.fromDateStr).format("DD"));
            allHolidayDates.push(element.fromDateStr);
            tempMonth.holidayDays = holidayDays;
            tempMonth.holidayCount = holidayCount;
            tempMonth.holidayDates = holidayDates;
          }
        }
      }
      console.log("templateData edit", templateData)
      setHolidayGridData(templateData);


      for (let index = 0; index < allHolidayDates.length; index++) {
        allHolidayDates[index] = convertDate(allHolidayDates[index])

      }


      setHolidayAllDates(allHolidayDates);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })
    // console.log(holidayDetails);
  }, [refresh])

  const handleDatePickerChange = (value) => {
    //console.log(value,'ooooooooooo');

    let joinedValue = value.join(",");
    let array = joinedValue.split(',');
    console.log(array, 'ooooooooooo');

    // const parsedValue = array?.map(item => (moment(item).format(API_DATE_FORMAT)))


    // let fyy = ((parsedValue[parsedValue.length - 1]).split('T')[0]).split('-')[0]
    // var now = parsedValue[parsedValue.length - 1].split('T')[0]

    console.log(array, 'editing valuessssssssss')
    // console.log(holidayAllDates, 'eeeeenewwdatesave dates')

    setNewDates(array);
  }

  const handleCloseMenu = () => {
    setOpen(false);

  }

  const onConfirmSubmit = async () => {

  // guard: prevents double-tap

  if (isApiCalled) return;

  setIsApiCalled(true);

  try {


    handleConfirmLogModalClose();

    // build payload

    const tempArr1 = [];

    for (let index = 0; index < newDates.length; index++) {

      let fyy = ((newDates[index]).split('T')[0]).split('-')[2];

      const now = reverseconvertDate(newDates[index].split('T')[0]);

      const tempArr = {

        currentYear: ((newDates[index]).split('T')[0]).split('-')[2],

        fromDate: now,

        financialYear: fyy + "-" + (parseInt(fyy) + 1),

        isActive: 0,

        extFlag: localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0

      };

      tempArr1.push({ ...tempArr });

    }

    // show loader and call API

    loaderService.showLoader();

    const response = await apiClient.post(

      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/editHoliday",

      tempArr1,

      {

        headers: { Authorization: "Bearer " + getLocalStorageItem('id_token') }

      }

    );

    // handle response 

    setOpen(false);

    if (response?.data?.status === "SUCCESS") {

      toast.success(response.data.description);

    } else {

      toast.error(response?.data?.description || "Failed to update holidays");

    }

    // maintain refresh/navigation logic

    if (refresh === false) {

      setRefresh(true);

      navigate('../holiday-list');

    } else {

      setRefresh(false);

      navigate('../holiday-list');

    }

  } catch (error) {

    console.error("Error - ", error);

    toast.error("Something went wrong while updating holidays");

  } finally {


    loaderService.hideLoader();

    setIsApiCalled(false);

  }

};
 

  const submitdata = () => {
    handleConfirmLogModalOpen();
  }

  const handleEditButtonChange = (e) => {

    setOpen(true)

  }

  const [previewHolidayColDef] = useState([
    {
      field: 'Month',
      headerName: 'Month',
      minWidth: 100,
      valueGetter: (params) => {
        if (params.row.month) {
          return params.row.month
        } else return '-'
      }
    },
    {
      field: 'nonOperatingDaysHit',
      headerName: 'ABEPL Holiday',
      headerClassName: 'super-app-theme--header',
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.holidayDays.join(" , ")} arrow>
            <Button variant="text" endIcon={<VisibilityIcon />}>
              {params.row.holidayDays.length}
            </Button>
          </Tooltip>

        )
      }
    }
  ])






  //const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>  Manage Holiday | ABEPL </title>
      </Helmet>

      {/* {
        (isLoading) ?
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
            <img src={loader} alt="loading..." />
          </div>
          : */}
          <Container maxWidth="xxl">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Manage Holiday
              </Typography>
              <Button variant="contained" startIcon={<EditIcon />} onClick={(e) => handleEditButtonChange(e)} >
                Edit
              </Button>
            </Stack>

            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <Card>

                <CardContent>
                  <Typography variant='subtitle1' sx={{ marginBottom: 2 }}>Non Operating Days</Typography>

                  <Box
                    sx={{
                      marginTop: 1,
                      height: '100%',
                      width: '100%',
                      '& .super-app-theme--cell': {
                        backgroundColor: 'rgba(224, 183, 60, 0.55)',
                        color: '#1a3e72',
                        fontWeight: '600',
                      },
                      '& .super-app.monsoonFactor100': {
                        backgroundColor: 'rgba(157, 255, 118, 0.49)',
                        color: '#1a3e72',
                        fontWeight: '600',
                      },
                      '& .super-app-theme--header': {
                        wordWrap: 'break-word',
                        wordBreak: 'break-all',
                        whiteSpace: 'initial'
                      },
                    }}
                  >
                    <DataGrid
                      getRowHeight={() => 'auto'}
                      autoHeight
                      columns={previewHolidayColDef}
                      rows={holidayGridData}
                      getRowId={(row) => row?.month}
                      experimentalFeatures={{ newEditingApi: true }}
                      hideFooterPagination
                      hideFooterSelectedRowCount
                    />


                  </Box>

                </CardContent>


                <Popover

                  open={Boolean(open)}
                  anchorEl={open}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
                  transformOrigin={{ vertical: 'bottom', horizontal: 'bottom' }}
                  PaperProps={{
                    sx: {
                      p: 1,
                      // width: window.innerWidth > 767 ? '34%' : '90%',
                      height: '50%',
                      '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                      },
                    },
                  }}

                >


                  <Calendar

                    //markFocused={true}
                    value={holidayAllDates}
                    onChange={(e) => handleDatePickerChange(e)}
                    plugins={[
                      <DatePanel style={{ position: 'inherit', visibility: 'visible' }}

                      />,
                    ]}
                    format={"DD-MM-YYYY"}
                    //  onMonthChange={(date) => handleCalenderMonth(date)}
                    style={{ width: '100%', height: 0 }}
                    multiple
                  />

                  &nbsp;
                  <Box display='flex' alignItems="center" justifyContent="center">
                    <Button sx={{ minWidth: 120 }} variant="contained" onClick={submitdata} >Submit</Button>
                    &nbsp;
                    &nbsp;
                    <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" onClick={handleCloseMenu}>Cancel</Button>

                  </Box>

                </Popover>

              </Card>

            </Paper>
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
          </Container>
      {/* } */}

    </>
  )
}

export default HolidayList